<template>
  <div class="home text-center">
    <HelloWorld msg="UFOs"/>
    <h1>
      Data Visualization
    </h1>
    <h2>
      Project
    </h2>
    <img src="@/assets/img/ufo_logo.svg" width="300" height="300">
    <h5 v-if="ufos.length > 0">
      {{ ufos.length }} observations from {{ firstDate }} to
      {{ lastDate }}
    </h5>
    <h5 v-else>Loading observations...</h5>
    <p>Visit the <router-link to="/map">map!</router-link></p>
  </div>
</template>

<script>
// @ is an alias to /src
import { DateTime } from 'luxon';
import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'home',
  props: ['ufos', 'firstMonth', 'lastMonth'],
  computed: {
    firstDate() {
      const startDate = Math.min(...this.ufos.map(d => d.properties.dateLuxon));
      return DateTime.fromMillis(startDate).toFormat('LLLL yyyy');
    },
    lastDate() {
      const endDate = Math.max(...this.ufos.map(d => d.properties.dateLuxon));
      return DateTime.fromMillis(endDate).toFormat('LLLL yyyy');
    },
  },
  components: {
    HelloWorld,
  },
};
</script>
